import { type UseQueryResult, useQuery } from 'react-query';
import {
  ApprovalProcessService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto,
} from '../../services/wealthlane-customer-services';

const useGetApprovalProcessList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_ApprovalProcess_ApprovalProcessDto[] | undefined,
  unknown
> => {
  const approvalProcessList = useQuery(['getApprovalProcessList'], async () => {
    const data = await handleRequest(
      ApprovalProcessService.getApiCustomerApiAppApprovalProcessApprovalProcess()
    );

    // Filter out Tax Deactivate Approval and ESPP Approval
    return data?.filter(
      (item) => item.name !== 'Tax Deactivate Approval' && item.name !== 'ESPP Approval'
    );
  });

  return approvalProcessList;
};

export default useGetApprovalProcessList;
